module.exports = __webpack_public_path__ + "modules/home/images/saas_1.png?a5c8602e";


//////////////////
// WEBPACK FOOTER
// ./modules/home/images/saas_1.png
// module id = 76
// module chunks = 0